import PodcastContainer from "./containers/PodcastContainer";
import "./App.css";

function App() {
  return (
    <div className="App">
      <PodcastContainer />
    </div>
  );
}

export default App;
